import { Commit } from '@/store/types'
import { TipoVariableApi, GrupoTipoVariableApi } from '@/store/modules/estaciones/types'
import { EstacionApi } from '../entities/Api'
import { getEnvironments } from '@/environments'
import { client as fetch } from './ClientService'

export interface EstacionesInterface {
  getGrupoTipoVariables(): Promise<Commit<GrupoTipoVariableApi>>
  getTipoVariables(id: number): Promise<Commit<TipoVariableApi>>
  getEstaciones(variable: number): Promise<Commit<EstacionApi[]>>
  getEstacion(estacion: number, variable: number, initDate: string, finalDate: string): Promise<Commit<any>>
  getEstacionFromGrupoTipoVariable(grupoTipoVariable: number, estacion: number): Promise<Commit<any>>
}

export class EstacionesService implements EstacionesInterface {
  env = getEnvironments()
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }
  async getGrupoTipoVariables (): Promise<Commit<GrupoTipoVariableApi>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/grupo_tipo_variable`)
      return { type: 'GRUPO_TIPO_VARIABLE_FETCHED', payload: response }
    } catch (e) {
      return { type: 'ESTACIONES_ERROR', payload: e }
    }
  }
  async getTipoVariables (id: number): Promise<Commit<TipoVariableApi>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/grupo_tipo_variable/${id}/tipo_variable`)
      return { type: 'TIPO_VARIABLE_FETCHED', payload: response }
    } catch (e) {
      return { type: 'ESTACIONES_ERROR', payload: e }
    }
  }
  async getEstaciones (variable: number): Promise<Commit<EstacionApi[]>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/tipo_variable/${variable}/estacion`)
      return { type: 'ESTACIONES_FETCHED', payload: response }
    } catch (e) {
      return { type: 'ESTACIONES_ERROR', payload: e }
    }
  }
  /**
   *
   * @param estacion
   * @param variable
   * @param initDate format YYYY-MM-DD
   * @param finalDate format YYYY-MM-DD
   */
  async getEstacion (estacion: number, variable: number, initDate: string, finalDate: string): Promise<Commit<any>> {
    try {
      const response: EstacionApi[] = await fetch(`${this.apiUrl}/api/estacion/${estacion}/${variable}/${initDate}/${finalDate}`)
      return { type: 'DATA_ESTACION_FETCHED', payload: response }
    } catch (e) {
      return { type: 'ESTACIONES_ERROR', payload: e }
    }
  }

  async getEstacionFromGrupoTipoVariable (grupoTipoVariable: number, estacion: number): Promise<Commit<any>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/grupo_tipo_variable/${grupoTipoVariable}/estacion/${estacion}`)
      return { type: 'DATA_ESTACION_GTV_FETCHED', payload: response }
    } catch (e) {
      return { type: 'ESTACIONES_ERROR', payload: e }
    }
  }
}
